import MenuModalBlock, { MenuModalBlockProps } from './MenuModalBlock';
import withInteractor from './MenuModalBlock.interactor';
import withPresenter from './MenuModalBlock.presenter';

export type { MenuModalBlockProps };
export default withInteractor(withPresenter(MenuModalBlock))
